import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function FloatingDock() {
  return (
    <div data-testid="floating-dock" className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 glass rounded-full px-2 py-2 flex items-center gap-1">
      <a
        href="viber://chat?number=%2B380957955234"
        target="_blank"
        rel="noreferrer"
        data-testid="dock-viber"
        title="Viber"
        className="w-11 h-11 rounded-full grid place-items-center text-bone hover:bg-bone/10 hover:text-brass transition-all"
      >
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor"><path d="M14.5 2C18 2 21 4.5 21 8v3c0 4-2.5 6.5-6 6.5l.5 3-3-2.5C8.5 17 5 14.5 5 11V8c0-3.5 2.5-6 6.5-6h3z" opacity=".15"/><path d="M11 5h2c2 0 3 1 3 3M11 7h2c1 0 2 .5 2 2M14.5 12c-.7-.2-1.5.2-2 1l-.5.7c-.5.5-1.5.5-2.5-.3-1-1-1.3-2-1-2.7l.5-.7c.5-.5.5-1.3 0-2L8 7c-.5-.6-1.4-.6-2 0-1.6 1.6-1.4 4.5 1 7s5.5 2.5 7 1c.6-.6.6-1.5 0-2l-1-1c-.4-.5-1.1-.5-1.7 0z" stroke="currentColor" strokeWidth="1.2" fill="none"/></svg>
      </a>
      <a
        href="https://wa.me/380957955234"
        target="_blank"
        rel="noreferrer"
        data-testid="dock-whatsapp"
        title="WhatsApp"
        className="w-11 h-11 rounded-full grid place-items-center text-bone hover:bg-bone/10 hover:text-brass transition-all"
      >
        <MessageCircle className="w-5 h-5" />
      </a>
      <a
        href="https://t.me/dzhavala_marmor"
        target="_blank"
        rel="noreferrer"
        data-testid="dock-telegram"
        title="Telegram"
        className="w-11 h-11 rounded-full grid place-items-center text-bone hover:bg-bone/10 hover:text-brass transition-all"
      >
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor"><path d="M22 3 2 11l6 2 2 7 4-4 6 5z" opacity=".2"/><path d="M22 3 2 11l6 2 9-7-7 9 9 6z" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinejoin="round"/></svg>
      </a>
      <a
        href="tel:+380957955234"
        data-testid="dock-call"
        className="ml-1 inline-flex items-center gap-2 bg-brass text-onyx px-4 py-2.5 rounded-full text-[0.7rem] tracking-[0.2em] uppercase font-semibold hover:bg-brassHi transition-colors"
      >
        <Phone className="w-3.5 h-3.5" /> Call
      </a>
    </div>
  );
}
